import * as React from 'react';
import { ProcedureRecipient } from 'common/schema/Procedure';
import { assertNever } from 'server/utils/typings/assertNever';
import { useConfigRecipientEnabled } from '../hooks/useConfigRecipientEnabled';
import { useThemeLabel } from '../../config/ClientConfigModule';
import { useTranslation } from 'react-i18next';

export interface ProcedureRecipientTitleProps {
  recipient: ProcedureRecipient;
}

export function ProcedureRecipientTitle(props: ProcedureRecipientTitleProps) {
  const { t } = useTranslation();
  const recipientEnabled = useConfigRecipientEnabled();
  const organizationName = useThemeLabel('organizationName');

  if (!recipientEnabled) return null;

  switch (props.recipient) {
    case ProcedureRecipient.Citizen:
      return (
        <span>{t('procedures.recipients.citizen', 'Persona Fisica')}</span>
      );
    case ProcedureRecipient.Employee:
      return <span>{t('procedures.recipients.employee', 'Dipendente')}</span>;
    case ProcedureRecipient.Company:
      return (
        <span>{t('procedures.recipients.company', 'Persona Giuridica')}</span>
      );
    default:
      assertNever(props.recipient);
  }
}
